<template>
    <div class="header" id="headerTemplate">
        <van-nav-bar :title="attrs.title||''" left-arrow @click-left="onClickLeft">
            <template #right v-if="actions.length">
                <van-popover get-container="#headerTemplate" v-model="showPopover" @select="selectClick" theme="dark"
                    trigger="click" :actions="actions" placement="bottom-end">
                    <template #reference>
                        <van-icon name="ellipsis" />
                    </template>
                </van-popover>
            </template>
        </van-nav-bar>
    </div>
</template>
<script>
    export default {
        name: 'headerTemplate',
        components: {
        },
        data() {
            return {
                showPopover: false,
                actions: [],
            }
        },
        created() {
            this.init()
        },
        computed: {
            attrs() {
                return this.$attrs
            }
        },
        methods: {
            init() {
                let { options } = this.$router
                let array = options.routes
                let studentRoutes = []
                let pathRoots = ['/sale/', '/student/']
                let nowPath = this.$route.path
                let pathR = ""

                for (let index = 0; index < pathRoots.length; index++) {
                    const element = pathRoots[index];
                    if (nowPath.indexOf(element) === 0) {
                        pathR = element
                    }
                }
                if (!pathR) {
                    return false
                }

                for (let index = 0; index < array.length; index++) {
                    let item = array[index];
                    if (item.path == pathR) {
                        studentRoutes = item.children
                    }
                }
                let actions = []
                if (studentRoutes.length) {
                    for (let index = 0; index < studentRoutes.length; index++) {
                        let item = studentRoutes[index];

                        if (item.meta && item.meta.topMenuShow && item.meta.title) {//&& item.name != this.$route.name
                            actions.push({
                                className: item.name == this.$route.name ? 'light' : '',
                                text: item.meta.title,
                                name: item.name,
                                path: item.path
                            })
                        }
                    }
                }
                this.actions = actions
            },
            selectClick({ name }) {
                this.$router.push({ name })
            },
            onClickLeft() {
                this.$router.go(-1)
            }
        }
    }
</script>

<style lang="scss" scoped>
    #headerTemplate    ::v-deep.light {
        color: #2f9afb;
    }
</style>